import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { KeyRound, ArrowRight, AlertCircle, ShieldCheck } from "lucide-react";
import "../styles/profissionalAcesso.css";

// ✅ Importação correta baseada no seu Navbar.js
import logo from "../assets/logo.png"; 

const ProfissionalAcesso = () => {
  const [codigo, setCodigo] = useState("");
  const [erro, setErro] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Efeito de partículas
  useEffect(() => {
    const canvas = document.getElementById("pa-particles");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];
    const particleCount = 40;

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 2 + 1,
        color: "rgba(253, 210, 18, " + (Math.random() * 0.3 + 0.1) + ")", // Amarelo
        speedX: Math.random() * 0.4 - 0.2,
        speedY: Math.random() * 0.4 - 0.2,
      });
    }

    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < particleCount; i++) {
        const p = particles[i];
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();

        p.x += p.speedX;
        p.y += p.speedY;

        if (p.x < 0 || p.x > canvas.width) p.speedX *= -1;
        if (p.y < 0 || p.y > canvas.height) p.speedY *= -1;
      }
    }

    animate();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const acessar = async (e) => {
    e.preventDefault();
    if (!codigo) return setErro("Digite o código de acesso.");

    setErro("");
    setIsLoading(true);

    try {
      const res = await axios.post(
        "https://api.ticketdovaqueiro.com/api/profissionais/acesso",
        { codigo }
      );

      localStorage.setItem("profissional", JSON.stringify(res.data));

      // Feedback visual rápido antes de navegar
      setTimeout(() => {
        // 🔹 CORREÇÃO: Sempre envia para o Painel de Entrada (lista de rodízios)
        // Independentemente se é Juiz ou Locutor, para evitar bugs de rodízio preso.
        navigate("/painel"); 
      }, 500);

    } catch (err) {
      setErro("Código inválido ou inativo. Verifique e tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pa-login-page">
      <canvas id="pa-particles" className="pa-particles-canvas"></canvas>

      <div className="pa-login-overlay">
        <motion.div 
          className="pa-card"
          initial={{ opacity: 0, scale: 0.9, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          {/* LOGO */}
          <div className="pa-logo-container">
            <img src={logo} alt="Ticket do Vaqueiro" className="pa-logo" />
          </div>

          <h2 className="pa-title">
            <ShieldCheck size={28} /> Área Restrita
          </h2>
          <p className="pa-subtitle">
            Acesso exclusivo para Juízes e Locutores.
          </p>

          <AnimatePresence>
            {erro && (
              <motion.div 
                className="pa-error"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
              >
                <AlertCircle size={18} /> {erro}
              </motion.div>
            )}
          </AnimatePresence>

          <form onSubmit={acessar} className="pa-form">
            <div className="pa-input-group">
              <label>Código de Acesso</label>
              <div className="pa-input-wrapper">
                <KeyRound size={20} className="pa-icon" />
                <input
                  type="text"
                  placeholder="DIGITE SEU CÓDIGO"
                  value={codigo}
                  onChange={e => {
                    setCodigo(e.target.value.toUpperCase()); // Força maiúsculo visualmente
                    setErro("");
                  }}
                  className="pa-input"
                  maxLength={6} // Assumindo códigos curtos
                />
              </div>
            </div>

            <motion.button 
              type="submit" 
              className="pa-button"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="pa-loader"></div>
              ) : (
                <>
                  ACESSAR PAINEL <ArrowRight size={20} />
                </>
              )}
            </motion.button>
          </form>

        </motion.div>
      </div>
    </div>
  );
};

export default ProfissionalAcesso;